module.exports = __webpack_public_path__ + "media/crosses/close-bold-4c679380.svg";